const zIndices = {
  hide: -1,
  auto: "auto",
  base: 0,
  docked: 10,
  dropdown: 1000,
  sticky: 1100,
  sticky1: 1101,
  sticky2: 1102,
  banner: 1200,
  overlay: 1300,
  modal: 1400,
  popover: 1500,
  tooltip: 1550, // otherwise tooltips will not be visible in modals
  skipLink: 1600,
  toast: 1700,
};

export default zIndices;
